var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22.655,
    viewBox: "0 0 25 22.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebb53e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.718,19.47a2.125,2.125,0,0,1-1.8,3.185H2.085a2.125,2.125,0,0,1-1.8-3.185L10.7,1.061a2.065,2.065,0,0,1,3.609,0L24.718,19.47ZM12.5,15.664a2.036,2.036,0,1,0,2,2.035A2.016,2.016,0,0,0,12.5,15.664ZM10.6,8.348l.322,6.018a.525.525,0,0,0,.52.5h2.107a.525.525,0,0,0,.52-.5L14.4,8.348a.527.527,0,0,0-.52-.56H11.124a.527.527,0,0,0-.52.56Z",
    transform: "translate(0 0)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/exclamation-triangle.71ca86a7.svg";
export { ForwardRef as ReactComponent };